import { render } from "./Jibaboom.vue?vue&type=template&id=15d760ef&scoped=true"
import script from "./Jibaboom.vue?vue&type=script&lang=js"
export * from "./Jibaboom.vue?vue&type=script&lang=js"

import "./Jibaboom.vue?vue&type=style&index=0&id=15d760ef&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d760ef"]])

export default __exports__